<template>
  <div class="share-container">
    <div class="share-title">{{ $t('_fx._fxhy') }}</div>
    <div class="share-content">
      <div class="share-info">
        <p class="share-tip">{{ $t('_fx._smfx') }}</p>
      </div>
      <div class="qrcode-section">
        <!-- 添加canvas元素 -->
        <canvas ref="qrCanvas" class="cz-qrcode"></canvas>
      </div>
      <div>
        <div class="limdbx">{{ shareUrl }}</div>
      </div>
      <div class="lkdesc">
        <div>{{ $t('_fx._jlsm') }}</div>
        <div>{{ $t('_fx._jlsm1', { a: 5 }) }}</div>
        <div>{{ $t('_fx._jlsm2', { a: 3 }) }}</div>
        <div>{{ $t('_fx._jlsm3', { a: 1 }) }}</div>
      </div>
      <div class="share-info">
        <!-- <p class="share-tip">{{ $t('_fx._smfxghy') }}</p> -->
        <div class="share-actions">
          <button class="download-btn" @click="onCopy()">{{ $t('_fx._fzlj') }}</button>
          <!-- <button class="download-btn" @click="downloadQRCode">下载二维码</button> -->
          <!-- <button class="refresh-btn" @click="refreshQRCode">刷新</button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import Config from '@/utils/config.js'
export default {
  name: 'shareVue',
  data() {
    return {
      shareUrl: '',
      qrCodeInstance: null
    }
  },
  mounted() {
    this.makeQRCode()
  },
  methods: {
    onCopy() {
      // copyData想要复制的内容
      this.$copyText(this.shareUrl)
        .then(() => {
          this.$message.success('copy success! ' + this.shareUrl)
        })
        .catch(() => {
          this.$message.error('copy fail')
        })
    },
    async makeQRCode() {
      try {
        // try {
        let user = this.$common.getInfo()
        if (user && user.uid) {
          // 只获取域名部分（不包含协议）
          this.shareUrl = Config.web_host + '/tv/signup?uid=' + user.uid
          if (process.env.NODE_ENV === 'development') {
            //this.shareUrl = 'http://localhost:8080/tv/signup?uid=' + user.uid
          }
        }

        // 生成新的二维码
        this.qrCodeInstance = await QRCode.toCanvas(this.$refs.qrCanvas, this.shareUrl, {
          width: 200,
          height: 200,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        })
        console.log('二维码生成成功')
      } catch (error) {
        console.error('二维码生成失败:', error)
      }
    }

    // downloadQRCode() {
    //   try {
    //     const canvas = this.$refs.qrCanvas
    //     if (canvas) {
    //       const link = document.createElement('a')
    //       link.download = 'share.png'
    //       link.href = canvas.toDataURL('image/png')
    //       link.click()
    //     }
    //   } catch (error) {
    //     console.error('下载二维码失败:', error)
    //     alert('下载失败，请重试')
    //   }
    // },

    // refreshQRCode() {
    //   this.makeQRCode()
    // }
  }
}
</script>

<style scoped>
.share-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.share-title {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 24px;
  color: #333;
}

.share-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.qrcode-section {
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.cz-qrcode {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.share-info {
  text-align: center;
}

.share-tip {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}

.share-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.download-btn,
.refresh-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.download-btn {
  background: #1890ff;
  color: white;
}

.download-btn:hover {
  background: #40a9ff;
}

.refresh-btn {
  background: #f0f0f0;
  color: #333;
  border: 1px solid #d9d9d9;
}

.refresh-btn:hover {
  background: #e6f7ff;
  border-color: #1890ff;
  color: #1890ff;
}

.limdbx {
  display: flex;
  border: dashed 1px #03a9f4;
  padding: 15px;
  border-radius: 10px;
}

.lkdesc {
  color: #8d8b8b;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .share-container {
    margin: 10px;
    padding: 15px;
  }

  .share-actions {
    flex-direction: column;
  }

  .download-btn,
  .refresh-btn {
    width: 100%;
  }
}
</style>
